import { render, staticRenderFns } from "./InfoBlockMsg.vue?vue&type=template&id=6aa99bfe&scoped=true&"
import script from "./InfoBlockMsg.vue?vue&type=script&lang=js&"
export * from "./InfoBlockMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa99bfe",
  null
  
)

export default component.exports